import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  TipoPreguntaLength: 0,
  TipoPregunta: [],
}

export default function preguntaReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_PREGUNTA:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_PREGUNTA:
      return {...state, saveLoader: action.payload}
    case actions.GET_PREGUNTA:
      return {...state, TipoPregunta: action.payload.TipoPregunta, TipoPreguntaLength: action.payload.TipoPreguntaLength}
    default:
      return {...state};
  }
}